import React from 'react';
import './About.css';

const About: React.FC = () => {
  const credentials = [
    {
      number: "01",
      title: "Doctor en Misionología",
      description: "Formación académica especializada en misiones y ministerio",
      icon: "zgfybbtk",
      gradient: "linear-gradient(135deg, #1e3a8a 0%, #2563eb 100%)"
    },
    {
      number: "02",
      title: "Misionero Experimentado",
      description: "Años de servicio misionero con impacto global",
      icon: "aabwqxsm",
      gradient: "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)"
    },
    {
      number: "03",
      title: "Pastor Respetado",
      description: "Liderazgo pastoral reconocido en la comunidad cristiana",
      icon: "fshosubk",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)"
    }
  ];

  return (
    <section id="acerca" className="about">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 className="section-title">Tu Mentor Pastoral</h2>
            <p className="about-description">
              Doctor en Misionología, misionero respetado y pastor con décadas de experiencia
              en el ministerio cristiano. Su reputación pastoral y experiencia ministerial
              lo convierten en el mentor ideal para líderes, pastores y ministros experimentados.
            </p>
            <div className="credentials">
              {credentials.map((cred, index) => (
                <div key={index} className="credential-card">
                  <div className="credential-badge" style={{ background: cred.gradient }}>
                    {cred.number}
                  </div>
                  <h4 className="credential-title">{cred.title}</h4>
                  <p className="credential-description">{cred.description}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="about-image">
            <img
              src="/img-hero.jpg"
              alt="Dr. Moisés Mejía"
              className="about-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;